import { getAPIHeaders } from '@/services/api.service';

export async function getLastCIEExport(projectId) {
    const response = await fetch(`/api/projects/${projectId}/CIEExports`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).pop();
}
export async function getCIEExport(projectId, CIEExportId) {
    const response = await fetch(`/api/projects/${projectId}/CIEExports/${CIEExportId}`, {
        headers: getAPIHeaders(),
    });
    return await response.json();
}

export async function createCIEExport(projectId, cieExport) {
    const response = await fetch(
        new Request(`/api/projects/${projectId}/CIEExports`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(cieExport),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('CIE Exports failed');
    }
}
